import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import Cookies from 'js-cookie';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import Img from '@common/Image';

import DownloadButton from './DownloadButton';

const DownloadCards = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  const [showDownloads, setShow] = useState(false);
  useEffect(() => {
    const downloadCookie = Cookies.get('_hm_templates');
    setShow(downloadCookie);
  }, []);
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4'>{title}</Heading>}
        <Row className='row-cols-md-2 g-3'>
          {list && list.map(card => (
            <div className='d-flex' key={card.id}>
              <div className='d-flex flex-fill border border-3 border-dark-grey-4 rounded p-3'>
                {card.image &&
                  <div className='col-6'>
                    <Img image={card.image.gatsbyImageData} file={card.image.file} />
                  </div>
                }
                <div className='col ps-1'>
                  {card.title && <Heading type='h3' className='h5'>{card.title}</Heading>}
                  {card.subtitle && <p>{card.subtitle}</p>}
                  {showDownloads &&
                    <div className='d-flex flex-row'>
                      {card.pdf?.file?.url &&
                        <DownloadButton
                          url={card.pdf.file.url}
                          copy='PDF'
                        />
                      }
                      {card.image?.file?.url &&
                        <DownloadButton
                          url={card.image.file.url}
                          copy='PNG'
                        />
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          ))}
        </Row>
      </Container>
    </Section>
  )
}

export default DownloadCards
